// ── Emirates Vapor: thumbnail gallery sync for Savor theme ──
(function(){
  function initThumbs(){
    document.querySelectorAll('.slideshow-controls__thumbnail').forEach(function(thumb){
      thumb.addEventListener('click', function(){
        thumb.scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'});
      });
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initThumbs);
  } else {
    initThumbs();
  }
})();
